import { mapGetters } from 'vuex'
import {Spinner} from 'spin.js'
import '../../../node_modules/spin.js/spin.css'
import CciImageGalleryModal from 'components/cciimagegallerymodal/CciImageGalleryModal.vue'

export default {
  data () {
    return {
      loadingSpinner: null
    }
  },
  created () {
    window.addEventListener('message', this.messageHandler, false)
  },
  mounted () {
    if (this.isDesktop()) {
      var elem = document.getElementsByClassName('scroll-wrapper')[0]
      if (elem !== undefined) {
        elem.style.overflow = 'hidden'
      }
    }
    if (this.isPhone()) {
      var elemArtHolder = document.getElementById('article-holder')
      elemArtHolder.style.width = '100%'
      elemArtHolder.style.left = '0%'
      elemArtHolder.style.paddingTop = '50px'
      elemArtHolder.style.background = 'white'
    }

    if (this.isParamsValid(this.$route.params.articleNr)) {
      let articleIndex = Number(this.$route.params.articleNr)
      this.$store.commit('setCurrentArticle', this.articles[articleIndex])
    } else if (this.articles[0] !== undefined) {
      this.$store.commit('setCurrentArticle', this.articles[0])
    }

    if (this.getOnlineUrl() === undefined) {
      this.showLoadingSpinner()
    }
  },
  computed: {
    articleHtml: function () {
      if (this.currentArticle !== undefined) {
        let onlineURL = this.getOnlineUrl()
        if (onlineURL !== undefined) {
          return onlineURL
        }
        if (this.currentArticle.jumpOriginArticle !== null) {
          return this.getEncodedResourceUrl(this.currentArticle.jumpOriginArticle.html, this.currentArticle.jumpOriginArticle.attributes.LastRev)
        }
        return this.getEncodedResourceUrl(this.currentArticle.html, this.currentArticle.attributes.LastRev)
      }
    },
    articleId: function () {
      if (this.currentArticle !== undefined) {
        return this.currentArticle.id
      }
    },
    ...mapGetters({
      opsUrl: 'getOpsUrl',
      articles: 'getArticles',
      currentArticle: 'getCurrentArticle',
      articleFontsize: 'getArticleFontsize',
      settings: 'getSettings',
      adsEnabled: 'getAdsEnabled',
      showImageGalleryInArticle: 'getShowImageGalleryInArticle'
    })
  },
  watch: {
    currentArticle: function (newValue) {
      let articleNumber = this.articles.indexOf(newValue).toString()
      this.$store.commit('setCurrentPage', newValue.page)
      if (!this.isPhone()) {
        this.$router.push({ name: 'articles', params: { articleNr: articleNumber }})
      }
    },
    articleFontsize: function (newValue) {
      // This only works if the font size of the elements is set by the em value.
      // Also it does not work if the epub is located on a different host than the web reader.
      this.updateFontSize(newValue)
    },
    showImageGalleryInArticle: function (newValue) {
      var scrollWrapper = document.getElementsByClassName('scroll-wrapper')[0]
      if (!newValue) {
        let iframe = document.getElementById(this.currentArticle.id + '-article')
        iframe.contentWindow.focus()
        scrollWrapper.style.display = 'block'
      } else {
        scrollWrapper.style.display = 'none'
      }
    }
  },
  methods: {
    isParamsValid (articleParam) {
      if (articleParam.match(/\d+$/) !== null) {
        let articleNumber = Number(articleParam.match(/\d+$/)[0])
        if (articleNumber <= this.articles.length) {
          return true
        }
      }
      return false
    },
    updateFontSize (fontSize) {
      var iframe = document.getElementById(this.currentArticle.id + '-article')
      var inner = iframe.contentDocument || iframe.contentWindow.document
      var html = inner.getElementsByTagName('html')[0]
      html.style.fontSize = fontSize + this.$store.state.articleFontSizeUnit
    },
    articleLoaded () {
      if (this.articleHtml === undefined) {
        return
      }
      var context = 'ContextArticleView'
      if (this.$route.name === 'articles') {
        context = 'ContextArticleList'
      }
      this.$cciEventTrackingPlugin.trackEvent(context, 'ActionArticleArticleView', this.currentArticle, this.currentArticle.attributes.Headline)
      if (this.getOnlineUrl() === undefined) {
        this.updateFontSize(this.articleFontsize)
      }

      this.removeLoadingSpinner()
      let iframe = document.getElementById(this.currentArticle.id + '-article')
      iframe.style.visibility = 'visible'
      iframe.contentWindow.focus()

      if (this.getOnlineUrl() === undefined) {
        var inner = iframe.contentWindow
        let adsEnabled = !this.$store.state.entitlements.includes('no-ads') && !this.$store.state.entitlements.includes('nie') && this.settings.gptAdCode !== undefined && this.settings.gptAdCode !== ''
        if (!adsEnabled && typeof inner.destroyAds === 'function') {
          inner.destroyAds()
        } else if (typeof inner.displayAds === 'function') {
          inner.displayAds()
        }
      }
    },
    showLoadingSpinner () {
      let spinnerContainer = document.getElementById(this._uid + 'loading-spinner-layer')
      if (this.loadingSpinner !== null) {
        this.loadingSpinner.spin(spinnerContainer)
        return
      }
      let opts = {
        lines: 12,
        length: 12,
        width: 5,
        radius: 13,
        scale: 1,
        corners: 1,
        color: '#000000',
        opacity: 0.25,
        rotate: 0,
        direction: 1,
        speed: 1,
        trail: 60,
        fps: 20,
        zIndex: 2e9,
        className: 'spinner',
        top: '50%',
        left: '50%',
        shadow: false,
        hwaccel: false,
        position: 'absolute'
      }
      this.loadingSpinner = new Spinner(opts).spin(spinnerContainer)
    },
    removeLoadingSpinner () {
      if (this.loadingSpinner !== null) {
        this.loadingSpinner.stop()
      }
    },
    getOnlineUrl () {
      if (this.currentArticle === undefined) {
        return
      }
      let onlineURL = this.currentArticle.attributes.OnlineURL
      if (this.settings.enableOnlineURLArticles !== undefined && this.settings.enableOnlineURLArticles && onlineURL !== undefined && onlineURL !== '') {
        return onlineURL
      }
      return
    },
    messageHandler (event) {
      let str = event.data
      var command = str
      // console.log(str)
      if (typeof str === 'string' || str instanceof String) {
        if (str.indexOf('?') > -1) {
          let n = str.indexOf('?')
          // console.log(n)
          try {
            command = str.slice(0, n)
          } catch (err) {
            console.log('From CciArticleModal.js')
            console.log(err.msg)
          }
        }
      }

      if (command === 'linkInArticleClicked.cci') {
        let n = str.indexOf('?')
        // console.log('linked in article , n : ' + n)
        try {
          let link = str.slice(n + 9, str.length)
          window.open(link, '_blank')
          // window.location.href = link
        } catch (err) {
          console.log('From CciArticleModal.js link in article clicked')
          console.log(err.msg)
        }
      }

      if (command === 'keydownInArticle.cci') {
        let n = str.indexOf('?')
        // console.log('keydownInArticle, n : ' + n)
        try {
          let keycode = str.slice(n + '?keycode='.length, str.length)
          if (keycode === '27') {
            if (this.$store.state.showImageGalleryInArticle) {
              this.$store.commit('setShowImageGalleryInArticle', false)
            }
          }
        } catch (err) {
          console.log('From CciArticleModal.js keydownInArticle')
          console.log(err.msg)
        }
      }

      if (command === 'imageGalleryClicked.cci') {
        this.$store.commit('setShowImageGalleryInArticle', true)
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('message', this.messageHandler)
  },
  components: {
    CciImageGalleryModal
  }
}
